import React from 'react';
import { Col } from 'react-grid-system';
import PropTypes from 'prop-types';

import Section from '../Section';
import Video from '../Video';

import styles from './videoSection.module.scss';

function VideoSection(props) {
  const {
    aspectRatio,
    title,
    videoUrl,
  } = props;

  return (
    <Section>
      <Col>
        {title && (<h2 className={styles.title}>{title}</h2>)}
        <Video videoSrc={videoUrl} aspectRatio={aspectRatio} title={title} />
      </Col>
    </Section>
  );
}

export default VideoSection;

VideoSection.propTypes = {
  aspectRatio: PropTypes.string,
  title: PropTypes.string,
  videoUrl: PropTypes.string.isRequired,
};

VideoSection.defaultProps = {
  aspectRatio: '4:3',
  title: '',
};
